import { LocalStorageValue } from './LocalStorageValue'

export class NumberLocalStorageValue extends LocalStorageValue<number> {
  constructor(key: string, defaultValue?: number) {
    super(
      key,
      (v: number) => v.toString(),
      (r: string) => Number(r),
      defaultValue,
    )
  }
}
